import { render, staticRenderFns } from "./FixedCosts.vue?vue&type=template&id=fbd5c7d4&"
import script from "./FixedCosts.vue?vue&type=script&lang=js&"
export * from "./FixedCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports